// themes/light.ts
import { colors } from '../colors';

export const lightTheme = {
  background: colors.white,                       // Background (BG)
  lightGray: colors.lightWhite,                   // Light Gray (Cinza leve)
  textBalloon: colors.white,                      // Text Balloon (Balão de texto)
  white: colors.white,                            // White (Branco)
  main: colors.primary,                           // Main (Main)
  main2: colors.primary,                          // Main 2 (Main 2)
  main3: colors.primaryLight80,                   // Main 3 (Main 3)
  activateNotificationsBG: colors.primaryLight40, // Activate Notifications Background (Ativar notificações BG)
  textAndButtons: colors.darkGrey3,               // Text and Buttons (Texto e botões)
  lightText: colors.darkGrey4,                    // Light Text (Texto leve)
  blue: colors.secondary,                         // Blue (Blue)
  alert: colors.alert,                            // Alert (Alerta)
  mediumGray: colors.darkGrey3,                   // Medium Gray (Cinza médio)
};